var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model',{staticClass:"tick-model",on:{"clickHandler":_vm.exit}},[_c('img',{staticClass:"success",attrs:{"src":require("@img/success.png")},on:{"click":_vm.exit}}),_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.num))])])}
var staticRenderFns = []

export { render, staticRenderFns }